import React from 'react';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import Button from '../../../Button';
import TextButton from '../../../TextButton';
import { buttonTypes, dataHooks, skins } from '../../constants';
import { classes } from './AccordionItemCaret.st.css.js';
const CaretButton = ({ showLabel, buttonType, skin, open, disabled, hover, collapseLabel, expandLabel, }) => {
    const skinProp = skin === skins.neutral ? 'dark' : 'standard';
    const isLabelShown = showLabel === 'always' || hover;
    const label = open ? collapseLabel : expandLabel;
    if (buttonType === buttonTypes.node && isLabelShown && label) {
        return React.createElement(React.Fragment, null, label);
    }
    if (buttonType === buttonTypes.button &&
        label &&
        // For this buttonType, showLabel default is 'always' if undefined.
        (showLabel === 'hover' ? hover : true)) {
        return (React.createElement(Button, { skin: skinProp, size: "small", priority: open ? 'secondary' : 'primary', disabled: disabled, dataHook: dataHooks.toggleButton, children: label }));
    }
    if (buttonType === buttonTypes.textButton) {
        const suffixIcon = open ? (React.createElement(ChevronUp, { size: "24px" })) : (React.createElement(ChevronDown, { size: "24px" }));
        return (React.createElement(TextButton, { skin: skinProp, suffixIcon: suffixIcon, disabled: disabled, dataHook: dataHooks.toggleButton, children: isLabelShown && label }));
    }
    return null;
};
function AccordionItemCaret(props) {
    return (React.createElement("div", { className: classes.toggleButton, "data-hook": "toggle-accordion-wrapper" },
        React.createElement(CaretButton, Object.assign({}, props))));
}
export default AccordionItemCaret;
//# sourceMappingURL=AccordionItemCaret.js.map